import axios from "axios";
import { getSessionToken } from "../utils/helpers/storage";
import { BASE_URL } from "./constant";

const axiosPrivate = axios.create({
  baseURL: BASE_URL,
});

axiosPrivate.interceptors.request.use((config) => {
  const token = getSessionToken("accessToken");

  const hostname = window.location.hostname; 
  const [tenantID, tenantInstance] = hostname.split(".")[0].split("_");

  config.params = config.params || {};
  config.headers.common.Authorization = `Bearer ${token}`;

  config.headers["X-Tenant-ID"] = tenantID;
  config.headers["X-Tenant-Instance"] = tenantInstance;

  return config;
});

export default axiosPrivate;
